// eslint-disable-next-line import/prefer-default-export
export const ChatTypes = {
  ADD_ACTIVE_ROOM: 'ADD_ACTIVE_ROOM',
  ADD_MESSAGE: 'ADD_MESSAGE',
  CLEAN_CHAT_ROOM: 'CLEAN_CHAT_ROOM',
  CLEAN_ACTIVE_CHAT: 'CLEAN_ACTIVE_CHAT',
  FREE_TO_CHOOSE_INITIAL: 'FREE_TO_CHOOSE_INITIAL',
  ADD_ALL_MESSAGES: 'ADD_ALL_MESSAGES',
  POP_NEW_MESSAGES: 'POP_NEW_MESSAGES',
  SOCKET_UPDATE: 'SOCKET_UPDATE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  SET_RESPONDING_MESSAGE: 'SET_RESPONDING_MESSAGE',
  CLEAR_RESPONDING_MESSAGE: 'CLEAR_RESPONDING_MESSAGE',
  SET_REPLYS: 'SET_REPLYS',
  UPDATE_REPLYS: 'UPDATE_REPLYS',
  ADD_REPLY: 'ADD_REPLY',
  ADD_LIKE: 'ADD_LIKE',
  DELETE_LIKE: 'DELETE_LIKE',
};
